import { useCallback, useEffect, useState } from "react";
import { fetchRfpUsers } from "../services/rfpsService";
import type { RfpOwnerUser } from "../types/rfp";

export type UseRfpUsersResult = {
  readonly users: readonly RfpOwnerUser[];
  readonly loading: boolean;
  readonly error: string | null;
  readonly reload: () => void;
};

export function useRfpUsers(): UseRfpUsersResult {
  const [users, setUsers] = useState<RfpOwnerUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const reload = useCallback(() => {
    setReloadToken((v) => v + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    void (async () => {
      try {
        const response = await fetchRfpUsers();
        if (cancelled) return;
        setUsers(response.data ?? []);
      } catch (e) {
        if (cancelled) return;
        const message = e instanceof Error ? e.message : "Failed to load owners";
        setError(message);
        setUsers([]);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [reloadToken]);

  return {
    users,
    loading,
    error,
    reload,
  };
}
